import { useCallback, useContext } from 'react'
import type { Filter_1_0_0 } from '@luxuryescapes/contract-data-event-schemas/lib/com.luxgroup'

import { trackEvent } from 'analytics/analytics'
import { mapGlobalSearchContextToSnowplowSearchEvent } from 'analytics/mapSnowplowSearchTracking'
import { searchEventWithContext } from 'analytics/snowplow/events'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'

export type ExperienceSearchFilterContext = Filter_1_0_0

export default function useTrackExperienceSearchFilter() {
  const globalSearchState = useContext(GlobalSearchStateContext)
  const { isAnyVariant: discoveryRevampEnabled } = useExperiment(
    Experiments.experiencesSearchDiscoveryRevamp,
  )

  return useCallback((filterContexts: ExperienceSearchFilterContext | Array<ExperienceSearchFilterContext>) => {
    if (!discoveryRevampEnabled) return

    const contexts = Array.isArray(filterContexts) ? filterContexts : [filterContexts]
    if (contexts.length === 0) return

    trackEvent(searchEventWithContext({
      searchEvent: { type: 'filters' },
      sortContext: { value: 'recommended' },
      searchContext: mapGlobalSearchContextToSnowplowSearchEvent({
        ...globalSearchState,
        searchVerticals: new Set(['experiences']),
      }),
      filterContexts: contexts,
    }))
  }, [discoveryRevampEnabled, globalSearchState])
}
